import { Scene } from 'scrollmagic'
import bus from '/javascripts/bus'
import UI from '/javascripts/utils/UI'
import scrollController from '/javascripts/utils/scrollController'

UI({
  component: '.js-page',
  header: '.js-page-header',
  content: '.js-page-contentContainer',
}, ({ header, content }) => {
  const state = { scene: null }

  check()
  bus.on('windowResize', check)

  if (document.readyState !== 'complete') {
    document.addEventListener('readystatechange', ({ target: { readyState } }) => {
      if (readyState === 'complete') check()
    })
  }

  function check() {
    state.scene && state.scene.destroy()
    setContentContainerHeight()
    initializeScene()
  }

  function setContentContainerHeight() {
    content.style.top = Math.floor(header.clientHeight) + 'px'
  }

  function initializeScene() {
    state.scene = new Scene({
      triggerElement: content,
      triggerHook: header.clientHeight / window.innerHeight,
      duration: header.clientHeight
    })

    state.scene.addTo(scrollController)
      .on('progress', ({ progress, target }) => bus.emit('onUpdateScrollFromTop', { progress, boundingClientRect: content.getBoundingClientRect() }))
  }
})
